export const KEY_API = '>uV6P(B4rKoQPjeAl=Mqv]|`FO;eG5XNH}?W%T($34>3c6%jC^gxN4-53[j4L=1';
export const METHOD_GET_ACCESS_PROFILES = 'listarPerfisAcesso';
export const METHOD_GET_COST_CENTERS = 'listarCentrosDeCustos';
export const METHOD_GET_DEPARTMENTS = 'listarDepartamentos';
export const METHOD_GET_OFFICES = 'listarCargos';
export const METHOD_GET_APPROVAL_GROUPS = 'listarGruposAprovacao';
